import React, { Component } from 'react';
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    FormText,
} from "reactstrap";
import * as Constant from '../../../constants/AppConstants';
import LoanForm from './LoanForm';

class Employed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salary: '',
            emailValid: '',
            office_emailValid: "",
            workStartYearValid: ""
            //   office_email:'',

        }

    }

    handleUserInputValidations(field, e) {



        switch (field) {
            case 'office_email':
                if (e.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) || e.target.value == "" || e.target.value == null ) {
                    this.setState({
                        office_emailValid: '',
                    
                    })
                    this.props.handleEnableSubmit("1");
                } else {
                    this.setState({
                        office_emailValid: 'is-invalid',
                    })
                    this.props.handleEnableSubmit("")

                }

                break;
            case 'workStartYear':
                if (e.target.value.match(/^\d{4}$/) && e.target.value <= (new Date().getFullYear()) && e.target.value >= 1990 || e.target.value == "" || e.target.value == null ) {
                    this.setState({
                        workStartYearValid: '',

                    })
                    this.props.handleEnableSubmit("1")
                } else {
                    this.setState({
                        workStartYearValid: 'is-invalid',

                    })
                    this.props.handleEnableSubmit("")
                }
                break;
            default:
                break;
        }
    }

    render() {
        let loan_status_check = window.localStorage.getItem('loan_status_check');
        return (
            <div className="fields">
                <FormGroup row>
                    <Col xs="12" md="1">
                        <Label htmlFor="text-input">Monthly Salary<span style={{color:"red"}}>*</span></Label>
                    </Col>
                    <Col xs="12" md="3">
                        <InputGroup className="input-prepend">
                            <InputGroupAddon style={{ height: "36px", marginTop: "5px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", textAlign: "center", paddingLeft: "15px", paddingTop: "13px" }}>
                                <i className="fa fa-inr"></i></InputGroupAddon>
                            <Input type="number" style={{ borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px" }} id="text-input" name="salary" placeholder="" className={this.props.salaryValid} value={loan_status_check == 'hide' ? "********" : this.props.salary} onChange={(event) => this.props.handleUserInput(event)} />
                        </InputGroup>
                    </Col>

                    <Col xs="12" md="1">
                        <Label htmlFor="select">Salary Mode<span style={{color:"red"}}>*</span></Label>
                    </Col>
                    <Col xs="12" md="3">
                        <Input type="select" name="salaryModeSelect" value={loan_status_check == 'hide' ? "********" : this.props.salaryModeSelect} id="select" onChange={(event) => this.props.handleUserInput(event)}>
                            <option value="0">Please select</option>
                            {this.props.salaryMode.map((data, key) =>
                                <option key={key} value={data.id}>{data.mode}</option>
                            )}
                        </Input>
                    </Col>

                    <Col xs="12" md="1">
                        <Label htmlFor="textarea-input">Company Name<span style={{color:"red"}}>*</span></Label>
                    </Col>
                    <Col xs="12" md="3">
                        <div className="companies_w">
                            <Input type="text" id="company-input" name="companyName" placeholder="" value={loan_status_check == 'hide' ? "********" : this.props.companyName} onChange={(event) => this.props.handleUserInput(event)} onFocus={(event) => this.props.showcompanylist(event)} /> {(this.props.showcompanyfilter == true && this.props.companies != [] && this.props.companies.length > 0) ?
                                <div className="companiesfilter">
                                    <ul>
                                        {this.props.companies.map((data, key) =>
                                            <li key={key} onClick={(event) => this.props.companyclick(event)} >{data.company_name}</li>
                                        )}
                                    </ul>
                                </div>
                                : ""}
                        </div>
                    </Col>

                </FormGroup>

                <FormGroup row>
                    <Col xs="12" md="1">
                        <Label htmlFor="textarea-input">Working since </Label>
                    </Col>

                    <Col xs="12" md="3">
                        <Input type="number" id="text-input" min={1} name="workStartYear" value={loan_status_check == 'hide' ? "********" : this.props.workStartYear} placeholder="YYYY"
                            onChange={(event) => this.props.handleUserInput(event)}
                            onBlur={(event) => this.props.handleUserInput(event)}
                            onKeyUp={this.handleUserInputValidations.bind(this, "workStartYear")} />

                        {
                            this.state.workStartYearValid != ""?
                            <label style = {{color:"Red", fontSize:"11px"}}>Please enter a correct year for working since</label>
                            :
                            ""
                            

                        }
                    </Col>

                    <Col xs="12" md="1">
                        <Label htmlFor="select">Designation</Label>
                    </Col>

                    <Col xs="12" md="3">
                        <Input type="select" name="designation" value={loan_status_check == 'hide' ? "********" : this.props.designation} id="designation" onChange={(event) => this.props.handleUserInput(event)}>
                            <option value="0">Please select</option>
                            {this.props.designations.map((data, key) =>
                                <option key={key} value={data.id}>{data.designation}</option>
                            )}
                        </Input>
                        {this.props.designation === "Other" ?
                            <div>
                                <Input type="text" id="text-input" name="designationOther" placeholder="" value={loan_status_check == 'hide' ? "********" : this.props.designationOther} onChange={(event) => this.props.handleUserInput(event)} onBlur={(event) => this.props.handleUserInput(event)} />
                                <FormText color="muted">Optional</FormText>
                            </div>
                            :
                            <div></div>
                        }
                    </Col>

                    <Col xs="12" md="1">
                        <label htmlFor="office-email-input">Office Email</label>
                    </Col>
                    <Col xs="12" md="3">
                        <Input type="email" id="office-email-input" name="office_email" onChange={(event) => this.props.handleUserInput(event)}
                            onBlur={(event) => this.props.handleUserInput(event)}
                            onKeyUp={this.handleUserInputValidations.bind(this, "office_email")}
                            className={this.state.emailValid} value={loan_status_check == 'hide' ? "********" : this.props.office_email} />


                            {
                                this.state.office_emailValid != ""?
                                <label style = {{color:"Red", fontSize:"11px"}}>Please enter a correct value for Office Email</label>
                                :
                                ""
                                

                            }
                    </Col>

                </FormGroup>


            </div>
        )
    }
}

export default Employed;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanForm/Employed.js